export const analyticsEvents = [
  "landing_viewed",
  "policy_selected",
  "impact_generated",
  "policy_detail_opened",
  "watchlist_toggled",
  "watchlist_opened",
  "source_opened",
  "share_previewed",
  "correction_draft_saved",
  "policy_question_resolved",
  "policy_question_continued"
] as const;

export type AnalyticsEvent = typeof analyticsEvents[number];

const allowedProperties = new Set(["policyId", "family", "stage", "channel", "resultState", "outcome", "topic"]);
const forbiddenKey = /(income|salary|health|address|profile|email|phone|name|query|text|url)/i;

export function buildAnalyticsEvent(event: AnalyticsEvent, properties: Record<string, string> = {}) {
  const safeProperties = Object.fromEntries(
    Object.entries(properties).filter(([key, value]) => allowedProperties.has(key) && !forbiddenKey.test(key) && value.length <= 80)
  );
  return {
    event,
    productId: "policy-impact",
    channel: "web",
    properties: safeProperties
  } as const;
}

export function track(event: AnalyticsEvent, properties: Record<string, string> = {}): void {
  const detail = buildAnalyticsEvent(event, properties);
  window.dispatchEvent(new CustomEvent("bakkwimpyo:analytics", {detail}));
  if (import.meta.env.DEV) return;
  void fetch("/api/events", {
    method: "POST",
    headers: {"content-type": "application/json"},
    body: JSON.stringify(detail),
    keepalive: true,
  }).catch(() => undefined);
}
